module.exports = __webpack_public_path__ + "img/h5_banner01.e8d30dd9.webp";